import { Button } from "@/dom/components/Button/Button";
import { ColorView } from "@/dom/components/ColorSelect/ColorSelect";
import { Column } from "@/dom/components/Panel/Column";
import { Panel } from "@/dom/components/Panel/Panel";
import { PanelBody } from "@/dom/components/Panel/PanelBody";
import { PanelHeader } from "@/dom/components/Panel/PanelHeader";
import { Row } from "@/dom/components/Panel/Row";
import { Typography } from "@/dom/components/Typography/Typography";
import { Furniture } from "@/state/Furniture";
import { formatPrice } from "@/utils/string";
import React, { useState } from "react";
import { Color } from "three";

import css from "./FurnitureDetails.module.css";

import cn from "classnames";
import { formatDimensions } from "@/utils/dimensions";

type FurnitureDetailsProps = {
    furniture: Furniture;
    onBack: () => void;
    onAdd: () => void;
};

export const FurnitureDetails: React.FC<FurnitureDetailsProps> = ({ furniture, onBack, onAdd }) => {
    return (
        <Panel paddingTop="20px">
            <PanelHeader onBack={onBack} title="" noUnderline />
            <PanelBody marginTop="12px">
                <Column gap="40px">
                    <Column gap="12px">
                        <Column gap="20px">
                            <Column gap="12px">
                                <Row>
                                    <Typography variant="title">{furniture.data.name}</Typography>
                                    <Typography variant="title">
                                        {formatPrice(furniture.data.price)}
                                    </Typography>
                                </Row>
                                <Typography variant="body">
                                    {formatDimensions(furniture.data.dimensions)}
                                </Typography>
                            </Column>
                            <Button onClick={onAdd} size="small">
                                Добавить
                            </Button>
                        </Column>
                        <hr />
                    </Column>
                    <FurnitureImageSections furniture={furniture} />
                    <Column gap="12px">
                        <Typography variant="body-medium">{furniture.data.description}</Typography>
                        <Typography variant="body">
                            {formatDimensions(furniture.data.dimensions)}
                        </Typography>
                    </Column>
                    <Column gap="12px">
                        <Typography variant="subtitle">Цвет</Typography>
                        <Row justify="flex-start">
                            {furniture.data.colors.map((color) => (
                                <ColorView
                                    key={color}
                                    color={new Color(color)}
                                    onClick={() => {}}
                                    isSelected={false}
                                    size="large"
                                />
                            ))}
                        </Row>
                    </Column>
                </Column>
            </PanelBody>
        </Panel>
    );
};

const FurnitureImageSections: React.FC<{ furniture: Furniture }> = ({ furniture }) => {
    const [currentImage, setCurrentImage] = useState(
        furniture.resources.catalogImagePaths[0] ?? "assets/no-image.jpg"
    );

    return (
        <Column gap="12px">
            <div className={css.imageContainer}>
                <img src={currentImage} alt="Furniture image" />
            </div>
            <Row justify="flex-start">
                {furniture.resources.catalogImagePaths.map((path, index) => (
                    <div
                        key={index}
                        className={cn(css.imageItem, currentImage === path && css.selected)}
                        onClick={() => setCurrentImage(path)}
                    >
                        <img src={path} alt="Furniture image" />
                    </div>
                ))}
            </Row>
        </Column>
    );
};
